<template>
    <article class="dml-product-thumb"
             :pid="model.productId"
             :data-redirect-url="model.url"
             :data-position="model.position"
             :data-ads-track="adsParParameters"
             @mouseover="fetchSecondImage()">
        <a v-if="model.stats" :href="model.stats.productsStatisticsUrl" class="dml-product-thumb__stats">
            <p>ProductId: {{model.stats.productId}}</p>
            <p>Score: {{model.stats.score}}</p>
            <p>Clicks: {{model.stats.clickCount}}</p>
            <p>Views: {{model.stats.viewCount}}</p>
            <p>LightboxViews: {{model.stats.lightboxViewCount}}</p>
            <p>Source: {{model.stats.source}}</p>
            <p>ProductSource: {{model.stats.productSource}}</p>
            <p>{{model.shop}}</p>
            <p v-if="model.stats.isNewest">
                <strong>Nowość</strong>
            </p>
        </a>
        <a :href="model.seoLink"
           rel="nofollow opener"
           :target="model.mobileTarget"
           :title="model.productName"
           v-on:contextmenu="productClicked"
           v-on:click.middle="productClicked"
           v-on:click="productClicked" class="dml-product-thumb__wrapper">
            <div>
                <div :class="['dml-product-thumb__image', {'dml-product-thumb__image--border': showCoupon}]"
                 data-trc="productThumb.picture"
                 data-t="8.1">
                <img v-if="model.isRenderImage"
                     :src="model.image.url"
                     :srcset="srcSet"
                     sizes="(min-width: 720px) 24vw, 47vw"
                     :alt="model.image.alt"
                     :title="model.image.title"
                     v-on:click="trackEvent('picture')" />
                <img v-else
                     :src="model.image.url"
                     :srcset="emptyImage"
                     :data-srcset="srcSet"
                     data-sizes="(min-width: 720px) 24vw, 47vw"
                     :alt="model.image.alt"
                     :title="model.image.title"
                     class="lazy"
                     v-on:click="trackEvent('picture')" />
                <div class="dml-product-thumb__second-image-wrapper" v-if="model.secondImage">
                    <img v-if="isSecondImageFetched"
                         class="dml-product-thumb__second-image"
                         :src="model.secondImage.url"
                         :srcset="srcSecondImageSet"
                         sizes="(min-width: 720px) 24vw, 47vw"
                         :alt="model.secondImage.alt"
                         :title="model.secondImage.title"
                         v-on:click="trackEvent('picture')" />
                </div>
                <dm-product-labels v-bind="labelsModel"
                                   v-on:labelClicked="trackEvent"
                                   v-on:couponClicked="couponClicked" />
            </div>
                <div class="dml-product-thumb__desc">
                <div v-if="showSimilarProductsButton"
                     :class="['dml-product-thumb__show-details-similar']"
                     v-on:click="showSimilar">
                    <span class="dml-product-thumb__show-details-similar--label">
                        Znajdź podobne
                    </span>
                    <dm-icon name="similar" :width="18" :height="18" />
                </div>
                <div v-else-if="isLightboxEnabled"
                     :class="['dml-product-thumb__show-details', {'dml-product-thumb__show-details--coupon': showCoupon}]"
                     v-on:click="showDetails">
                    <dm-icon name="search-plus" :width="18" :height="18" />
                </div>
                <p v-if="model.isNotActive" class="_smra">Niedostępny</p>
                <dm-product-price v-else :priceModel="priceModel"
                                  linkType="span"
                                  v-on:click.native="trackEvent('price')" />
                <h4 v-if="!model.hideProductName"
                    class="dml-product-thumb__title"
                    data-t="8.2"
                    v-on:click="trackEvent('product_name')">
                    {{model.productName}}
                </h4>
                <span v-if="shipmentText"
                      :class="['dml-product-thumb__shipment', {'dml-product-thumb__shipment--free': model.freeShipping}]"
                      v-on:click="trackEvent('delivery')">
                    <dm-icon v-if="model.freeShipping" name="truck-fill" :width="16" :height="16" />
                    {{shipmentText}}
                </span>
                <span v-if="hasSizes"
                      class="dml-product-thumb__sizes"
                      v-on:click="trackEvent('size')">
                    {{model.sizesText}}
                </span>
                <span v-if="dropshippingSettings"
                      class="dml-product-thumb__eta"
                      v-on:click="dropshippingInfoClicked"
                      v-on:mouseover="hoverDropshippingInfo"
                      v-on:mouseleave="hideDropshippingInfo">
                    <dm-icon class="dml-product-thumb__eta-icon" name="question-circle" :width="14" :height="14" />
                    Długa dostawa
                    <dm-dropshipping-info v-if="isDropshippingInfoVisible"
                                          class="dml-product-thumb__dropshipping-info"
                                          className="dml-dropshipping-info"
                                          :deliveryTimeInfo="dropshippingSettings.deliveryTimeInfo"
                                          v-on:outside="handleClickOutsideDropshipping"
                                          :iconsSetVersion="iconsSetVersion"
                                          v-on:close="closeDropshippingInfo('close')"
                                          v-on:cta="closeDropshippingInfo('cta')" />
                </span>
                <span class="dml-product-thumb__omnibus" v-if="hasDiscount">*najniższa cena w okresie 30 dni przed obniżką</span>
            </div>
            </div>
            <div v-if="showMoreButtons" :class="moreButtonsCss +' dml-product-thumb__more'">
                <a class="dml-product-thumb__more-btn dml-product-thumb__more-btn__showdetails"
                   v-on:click="showDetails" :href="getHrefForDetailsButton" target="_blank">
                    <span>Szczegóły</span>
                </a>
                <span class="dml-product-thumb__more-btn dml-product-thumb__more-btn__gotoshop"
                   v-on:click="trackGoToShop">
                    <span>Idź do sklepu</span>
                </span>
            </div>
        </a>
        <div v-if="!model.hideLikes"
             class="dml-product-thumb__like"
             v-on:click="trackEvent('like')"
             data-trc="productThumb.like">
            <dm-like-button v-if="!model.hideLikes && model.likesComponent"
                            size="14"
                            :model="model.likesComponent" />
        </div>
    </article>
</template>
<script>
    import debounce from '~/utils/debounce.js';
    import * as types from '../../store/types.js';
    import { SIZES } from '../../utils/screen-sizes.js';
    import productListViewsTracker from '../../modules/product-list-views-tracker.js';
    import LikeButton from './like-button-component.vue';
    import ProductPrice from './product-price-component.vue';
    import ProductLabels from './product-labels-component.vue';
    import IconComponent from '../shared/icon-component.vue';
    import DropshippingInfo from './dropshipping-info.vue';

    const PLACES = { promotedProduct: 'promotedProduct' };

    export default {
        name: 'dm-product-item',
        data() {
            return {
                emptyImage: 'data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAQAAABqrk9lAAAADklEQVR42mNkgANGipkAAYEACAqFE8kAAAAASUVORK5CYII=',
                isDropshippingInfoVisible: false,
                isSecondImageFetched: false,
                isMouseOver: false
            };
        },
        components: {
            'dm-like-button': LikeButton,
            'dm-product-price': ProductPrice,
            'dm-product-labels': ProductLabels,
            'dm-icon': IconComponent,
            'dm-dropshipping-info': DropshippingInfo,
        },
        created() {
            this.debouncedTrackDropshippingHover = debounce(this.trackDropshippingHover.bind(this), 500);
        },
        mounted() {
            if (this.trackViews) {
                productListViewsTracker.registerElement(this.$el);
            }
        },
        beforeDestroy() {
            productListViewsTracker.unregisterElement(this.$el);
        },
        props: {
            model: {
                type: Object,
                required: true,
            },
            inLightbox: {
                type: Boolean,
                default: null,
            },
            place: {
                type: String,
                required: false,
                validator(val) {
                    return PLACES.hasOwnProperty(val);
                },
            },
            isProductList:{
                type: Boolean,
                default: false
            },
            isHovered: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            dropshippingSettings() {
                return this.model.dropshippingSettings;
            },
            iconsSetVersion() {
                return DM.Config.IconsSetVersion;
            },
            isLightboxEnabled() {
                return DM.Config.isLightboxEnabled && !this.model.forceLightboxDisable;
            },
            showSimilarProductsButton() {
                return DM.Config.isSplendiProductTileExtraButtonsSimilar && this.isProductList;
            },
            openProductDetails() {
                return DM.Config.openProductDetails;
            },
            getHrefForDetailsButton(){
                if (this.openProductDetails) {
                    return this.model.seoLink;
                }else {
                    return null;
                }
            },
            priceModel() {
                return this.model.priceModel || {
                    discount: this.model.discountPercent,
                    price: this.model.priceText,
                    oldPrice: this.model.oldPriceText
                };
            },
            trackViews() {
                return !!this.$store && !this.model.ctrViewsCountDisabled;
            },
            showCoupon() {
                return !this.model.hideCoupon && this.model.isCouponAttached;
            },
            labelsModel() {
                return {
                    url: this.model.url,
                    coupon: this.model.coupon,
                    productId: this.model.productId,
                    labelsGroups: this.model.badges,
                    discountPercent: this.model.discountPercent,
                    showCoupon: this.showCoupon,
                    isLightboxEnabled: this.isLightboxEnabled,
                    promoSale: this.promoSale
                }
            },
            promoSale() {
                if (this.model.promoSaleBadgeImageUrl && this.model.promoSaleBadgeLargeImageUrl) {
                    return {
                        badgeImageUrl: this.model.promoSaleBadgeImageUrl,
                        badgeLargeImageUrl: this.model.promoSaleBadgeLargeImageUrl
                    }
                }

                return null
            },
            showShopName() {
                return this.model.showShopName && this.model.shopName && this.model.brandName && this.model.brandName.toLowerCase() !== this.model.shopName.toLowerCase()
            },
            shipmentText() {
                const textToDisplay = this.model.shipmentText || 'Sprawdź opcje dostawy';
                return this.model.showShipmentText ? textToDisplay : "";
            },
            srcSet() {
                return `${this.model.image.smallUrl} 185w,
                        ${this.model.image.mediumUrl} 245w,
                        ${this.model.image.largeUrl} 335w`;
            },
            srcSecondImageSet() {
                return `${this.model.secondImage.smallUrl} 185w,
                        ${this.model.secondImage.mediumUrl} 245w,
                        ${this.model.secondImage.largeUrl} 335w`;
            },
            hasSizes() {
                return this.model.showSizesText;
            },
            hasDiscount() {
                return this.model.discountPercent;
            },
            moreButtonsCss(){
                return this.isHovered ? 'dml-product-thumb__more-visible' : '';
            },
            showMoreButtons(){
                return DM.Config.isSplendiProductTileExtraButtonsDetails && this.isProductList;
            },
            adsParParameters() {
                if (this.model.sendWave){
                    return this.model.adsParParameters;
                }
            }
        },
        methods: {
            showDetails(event) {
                this.trackEvent('show_details_btn');
                if(!this.openProductDetails){

                    if (this.isLightboxEnabled && event.type !== 'contextmenu' && event.type !== 'mouseup') {
                        event.preventDefault();
                        event.stopPropagation();
                        event.currentTarget.setAttribute('href', this.model.seoLink);
                        this.openLightbox();
                    }
                }
            },
            showSimilar(event){
                this.trackEvent('show_similar_btn');
                event.target.setAttribute('data-show-similar-only', 'true')
            },
            fetchSecondImage() {
                this.isSecondImageFetched = true;
            },
            productClicked(event) {
                event.currentTarget.setAttribute('href', this.model.url);
                event.type !== 'contextmenu' && event.type !== 'mouseup' && this.$emit('productClick');
            },
            couponClicked(e) {
                e.preventDefault();
                e.stopPropagation();
                this.$store.dispatch(types.COUPON_CLICK, this.model.productId);
                this.openLightbox();
            },
            openLightbox() {
                const { model, inLightbox } = this;
                const category = window.innerWidth >= SIZES.LARGE ? 'd_lightbox' : 'm_lightbox';

                this.$ga.trackEvent({
                    category,
                    action: 'click_lightbox_tile',
                    label: model.shopId
                });
                this.$store.dispatch(types.PRODUCT_CLICK, { ...model, inLightbox });
            },
            trackEvent(label, eventAction) {
                const category = window.innerWidth >= SIZES.LARGE ? 'd_product_tile' : 'm_product_tile';
                const isRedirecting = label !== 'show_details' || !this.isLightboxEnabled;
                const action = eventAction || (isRedirecting ? 'click' : 'click_lightbox');

                this.$ga.trackEvent({
                    category,
                    action,
                    label
                });
            },
            trackDropshippingHover() {
                this.isDropshippingInfoVisible && this.trackEvent('dropshipping', 'hover');
            },
            dropshippingInfoClicked(e) {
                e.preventDefault();
                e.stopPropagation();
                this.trackEvent('dropshipping');

                if (!this.isDropshippingInfoVisible) {
                    this.showDropshippingInfo();
                }
            },
            closeDropshippingInfo(trigger) {
                this.hideDropshippingInfo();
                this.trackEvent(trigger, 'popup');
            },
            hoverDropshippingInfo() {
                if (window.innerWidth >= SIZES.LARGE) {
                    this.showDropshippingInfo();
                    this.debouncedTrackDropshippingHover();
                }
            },
            showDropshippingInfo() {
                this.isDropshippingInfoVisible = true;
            },
            hideDropshippingInfo() {
                this.isDropshippingInfoVisible = false;
            },
            handleClickOutsideDropshipping() {
                if (window.innerWidth < SIZES.LARGE) {
                    this.closeDropshippingInfo('click_outside');
                }
            },
            trackGoToShop(){
                this.trackEvent('go_to_shop_btn');
            }
        }
    };
</script>
